import { useTranslations } from '@crystal/translator'

import { ScreenViews, useViewData } from '../lib'

import styles from './account-portal.module.scss'
import { FormContainer } from './layout/FormContainer'

interface Translations {
  title: string
  subtitle: string
}

const CONFIRMATION_SCREEN_COPIES: Record<string, Translations> = {
  [ScreenViews.ACTIVATE_CONFIRMATION_SCREEN]: {
    title: 'sent.email.confirmation.title',
    subtitle: 'sent.email.confirmation.subtitle',
  },
  [ScreenViews.RESET_PASSWORD_CONFIRMATION_SCREEN]: {
    title: 'sent.password.reset.email.title',
    subtitle: 'sent.password.reset.email.subtitle',
  },
}

export const EmailConfirmation = () => {
  const t = useTranslations()
  const { viewData } = useViewData()

  const { title, subtitle } = CONFIRMATION_SCREEN_COPIES[viewData.screenId]
  return (
    <FormContainer>
      <h1 className={styles['title']}>{t(title)}</h1>
      <p className={styles['subtitle']}>{t(subtitle)}</p>
    </FormContainer>
  )
}
